module.exports = __webpack_public_path__ + "img/star1_1.e0820997.svg";